module.exports = __webpack_public_path__ + "img/home1.d820ff4b.png";